/**
 * Centralized API Configuration (JavaScript version for build tools)
 * Single source of truth for all backend API URLs
 */

export const DEFAULT_API_URL = 'https://api.develop.meetings.sangoma.com';

export function deriveApiUrlFromHostname(hostname) {
  const commonPrefix = 'admin.';

  console.log('======deriveApiUrlFromHostname hostname', hostname);
  // Ephemeral ticket UI always uses the shared develop API backend
  if (hostname.endsWith('.test.meetings.sangoma.com')) {
    return DEFAULT_API_URL;
  }

  if (hostname.startsWith(commonPrefix) && hostname.endsWith('.meetings.sangoma.com') ) {
    // Default pattern: prepend 'api.' to hostname
    return `https://api.${hostname.slice(commonPrefix.length)}`;
  }

  return DEFAULT_API_URL;
}

export function getApiBaseUrl(isDevMode) {
  if (isDevMode) {
    return '/api';
  }

  // In browser environment, derive API URL from current hostname
  if (typeof window !== 'undefined' && window.location?.hostname) {
    return deriveApiUrlFromHostname(window.location.hostname);
  }
}

export function getApiEndpoint(endpoint, isDevMode) {
  const baseUrl = getApiBaseUrl(isDevMode);
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${normalizedEndpoint}`;
}

